import { Link } from "react-router-dom";
import { articles, categories } from "@/mocks/articles";
import ArticleCard from "@/components/feature/ArticleCard";
import SectionHeading from "@/components/base/SectionHeading";

export default function RankingSection() {
  const ranked = [...articles].sort((a, b) => b.heat - a.heat).slice(0, 8);
  const focus = articles.find((a) => a.heat > 9000 && a.category !== "fashion") ?? articles[2];

  return (
    <section id="ranking" className="scroll-mt-28 border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="Top Chart"
          title="今日热瓜榜"
          description="综合阅读、收藏、分享与讨论时长，按最近 72 小时数据加权计算，每两小时更新。"
          action={
            <Link
              to="/#latest"
              className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 hover:text-primary-800"
            >
              查看完整榜单 <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          }
        />

        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <ol className="lg:col-span-7">
            {ranked.map((article, index) => (
              <li key={article.slug} className="border-b border-background-200 last:border-none">
                <Link
                  to={`/article/${article.slug}`}
                  className="group flex items-center gap-4 py-4 transition-colors hover:bg-background-50 md:gap-6"
                >
                  <span
                    className={`w-10 flex-shrink-0 text-center font-heading text-2xl font-bold md:text-3xl ${
                      index < 3 ? "text-accent-500" : "text-background-400"
                    }`}
                  >
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block font-heading text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-700 md:text-lg">
                      {article.title}
                    </span>
                    <span className="mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
                      <span className="rounded-full bg-background-200 px-2 py-0.5 text-foreground-700">
                        {article.categoryName}
                      </span>
                      <span>{article.date}</span>
                    </span>
                  </span>
                  <span className="flex flex-shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-accent-600">
                    <i className="ri-fire-line" aria-hidden="true"></i>
                    {(article.heat / 1000).toFixed(1)}k
                  </span>
                </Link>
              </li>
            ))}
          </ol>

          <aside className="lg:col-span-5">
            <p className="mb-3 flex items-center gap-2 text-xs font-medium uppercase tracking-[0.22em] text-foreground-500">
              <i className="ri-focus-3-line" aria-hidden="true"></i>
              本周聚焦
            </p>
            <ArticleCard article={focus} variant="overlay" />

            <div className="mt-6 rounded-lg border border-background-200 bg-background-50 p-5">
              <h4 className="font-heading text-base font-bold text-foreground-950">热门标签</h4>
              <div className="mt-3 flex flex-wrap gap-2">
                {categories.map((cat) => (
                  <Link
                    key={cat.key}
                    to="/#categories"
                    className="rounded-full bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-900 transition-colors hover:bg-secondary-200"
                  >
                    <i className={`${cat.icon} mr-1`} aria-hidden="true"></i>
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}